import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import './WhatWeDo.css';

const industries = [
  {
    title: 'AJERA EXPORT',
    short: 'Agro Export',
    tag: 'Agriculture',
    desc: 'Ajera Export delivers premium agro products to global markets with strong quality, compliance, and sustainability standards.',
    link: 'https://ajeraexport.ajeragroup.com/',
    color: '#16a34a',
  },
  {
    title: 'AJERA INFOTECH',
    short: 'IT Solutions',
    tag: 'Technology',
    desc: 'Ajera Infotech provides scalable IT solutions, digital transformation, and modern enterprise platforms.',
    link: 'https://infotech.ajeragroup.com/',
    color: '#2563eb',
  },
  {
    title: 'AJERA BUILTTECH',
    short: 'Construction',
    tag: 'Infrastructure',
    desc: 'Ajera Builttech specializes in innovative construction solutions and high-quality infrastructure projects.',
    link: 'https://buildtech.ajeragroup.com/',
    color: '#d97706',
  },
];

const WhatWeDo: React.FC = () => {
  const [active, setActive] = useState(0);
  const current = industries[active];

  return (
    <>
      <PageHeader
        breadcrumb="What we do"
        title="What We Do"
        subtitle="Building powerful businesses across industries."
      />

      <div className="what-section">
        {/* LEFT */}
        <div className="what-left">
          <span className="what-eyebrow">Our Reach</span>
          <h1>Perpetually<br />Adaptive<br />Enterprise</h1>
          <p>Ajera builds future-ready enterprises across Agro, IT, and Construction — each division engineered for global impact.</p>
        </div>

        {/* MIDDLE */}
        <div className="what-middle">
          <span className="industries-title">Industries</span>
          <div className="industry-tabs">
            {industries.map((item, index) => (
              <div
                key={item.title}
                className={`industry-tab ${active === index ? 'active' : ''}`}
                style={{ '--tab-color': item.color } as React.CSSProperties}
                onClick={() => setActive(index)}
              >
                <div className="industry-tab__info">
                  <span className="industry-tab__name">{item.short}</span>
                  <span className="industry-tab__tag">{item.tag}</span>
                </div>
                <svg className="industry-tab__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="industry-display" key={active} style={{ '--card-color': current.color } as React.CSSProperties}>
          <div className="industry-display__header">
            <span className="industry-display__tag">{current.tag}</span>
          </div>
          <h2>{current.title}</h2>
          <p>{current.desc}</p>
          <button
            className="know-more-btn"
            onClick={() => window.open(current.link, '_blank')}
          >
            Explore Division
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default WhatWeDo;